module.exports = __webpack_public_path__ + "static/media/resize_w.1bf588b8.svg";